import React, {useState} from 'react'
import objetAgenda from '../../../utils/ObjetAgenda'
import NavMonth from '../../NavMonth/NavMonth'
import MapAgenda from '../../MapAgenda/MapAgenda'
import BgAgenda from '../../../assets/BgAgenda.jpg'


const Agenda = () => {

    const [data, setData] = useState(objetAgenda)

   
    let newArray = []
    const FunctionModify = (e) => {
        console.log(e.deetail);
        let eTargetValue = e.target.value
        if(eTargetValue === "Tous")

            setData(objetAgenda)

        else{
            newArray = objetAgenda.filter((item) => {
                return item.month.includes(eTargetValue)})

            setData(newArray)
        }
    }

    return (
        <div>
    
            <div  style={{backgroundImage: `url(${BgAgenda})`, height: 400+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover'}} className="text-center h1 text-bordeaux  p-2">
              Agenda  
            </div>

            <NavMonth  onClick={FunctionModify}  />

            <div className="container-fluid">

                <div className="row justify-content-md-center">
                    <MapAgenda TransferProps={data} />
                </div>

            </div>

        </div>
    )
}

export default Agenda


